import React from 'react';
import {getServerTexts} from './texts';
import {EmptyState} from './EmptyState';

export async function renderEmptyState(root) {
    await getServerTexts();

    root.render(<EmptyState />);
}
